<template>
  <div class="container sxsw-scraper index">
    <h1 class="title">SXSW Events (official)</h1>

    <div class="section events">
      <div class="row">
        <div class="col">
          <h2>Events
            <small v-if="!loadingEvents" class="text-muted">All {{events.length}} of them </small>
            <small v-else>loading...</small>
            <button v-if="!loadingEvents" @click.stop.prevent="onExportKeywordsList()" class="btn btn-outline-info btn-sm" >Export KeywordsMap</button>
          </h2>
          <SxswEvent v-for="evt in events" :key="evt.event_id" :evt="evt" :keywords="keywords[evt.event_id]"/>
        </div>
        <div class="col-4">
          <h2>Keywords
            <small v-if="!loadingEventsKeywords" class="text-muted">{{eventsKeywords.length}}</small>
            <small v-else>loading...</small>
          </h2>
          <div v-for="(keyword, i) in eventsKeywords" :key="keyword+i">{{keyword}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './../style/sxsw.scss'
import SxswEvent from './../components/SxswEvent.vue'
import { tokenMixin } from 'rph-slides-vue/src/mixins/tokenMixin.js'

export default {
  name: 'SxswEventIndex',
  components: { SxswEvent },
  mixins: [tokenMixin],
  data () {
    return {
      count: 0,
      events: [],
      eventsKeywords: [],
      keywords: {},
      loadingEvents: false,
      loadingEventsKeywords: false
    }
  },
  computed: {},
  created () {
    this.$socket.emit('/sxsw/events', { order: 'asc' }, this.onEventsUpdate.bind(this))
    this.$socket.on('/sxswscraper/keywords', this.onKeywordsUpdate.bind(this))
    this.$socket.emit('/sxswscraper/keywords', this.onKeywordsUpdate.bind(this))
    this.$socket.emit('/sxsw/events/keywords', this.onEventsKeywordsUpdate.bind(this))
    this.loadingEvents = true
    this.loadingEventsKeywords = true
  },
  methods: {
    onEventsUpdate (resp) {
      // console.log('onEventsUpdate', resp)
      this.events = resp.data
      this.loadingEvents = false
    },
    onKeywordsUpdate (resp) {
      // console.log('onKeywordsUpdate', resp)
      this.keywords = resp.data
    },
    onEventsKeywordsUpdate (resp) {
      // console.log(resp)
      this.eventsKeywords = resp.data
      this.loadingEventsKeywords = false
    },
    onExportKeywordsList () {
      const timeStr = new Date().toISOString().replace(/:/g, '-')
      const blob = new Blob([JSON.stringify(this.keywords, null, 2)], { type: 'application/json' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'keywords (' + timeStr + ').json'
      link.click()
      URL.revokeObjectURL(link.href)
    }
  }
}
</script>
